import React from 'react';

import { ReactComponent as Grid } from './grid.svg';

function FarmbotGridIcon() {
  return <Grid width={18} />;
}

export default FarmbotGridIcon;
